export default __webpack_public_path__ + "static/media/img_job_07.81218fe3.jpg";